
const env = import.meta.env;

const stripTrailingSlash = (url: string) => url?.replace(/\/+$/, '');

const getHostname = () => (typeof window !== 'undefined' ? window.location.hostname : '');
const isGenofxHost = (host: string) => /(^|\.)genofx\.com$/i.test(host);
const runtimeHost = getHostname();

const runtimeApiBase = 'https://api.genofx.com';

const resolvedApiBase = stripTrailingSlash(env.VITE_API_BASE || runtimeApiBase);

// Detect environment from API base URL
const IS_PRODUCTION = resolvedApiBase.includes('api.genofx.com') || isGenofxHost(runtimeHost);
const IS_DEV = !IS_PRODUCTION;

/**
 * Centralized configuration
 * All URLs derived from VITE_API_BASE to minimize env variables
 * 
 * Uses production GenofX domains (dash, share, api)
 */
const CONFIG = {
    // Environment detection
    IS_PRODUCTION,
    IS_DEV,

    // API Base (Lightsail — auth, launch, stream, billing)
    API_BASE: resolvedApiBase,

    // Worker URL (Cloudflare Worker — email, ads, blog, catalog, stats)
    WORKER_URL: 'https://w.genofx.com',
    
    // Derived URLs - computed based on environment
    get APP_URL() {
        return 'https://dash.genofx.com';
    },
    get SHARE_URL() {
        return 'https://share.genofx.com';
    },
    get PUBLIC_API_URL() {
        return `${this.API_BASE}/api/v1`;
    },
    get WEBHOOK_BASE_URL() {
        return `${this.API_BASE}/api/webhooks`;
    },
    get AUTH_URL() {
        return `${this.APP_URL}/auth/signup`;
    },
    get OAUTH_REDIRECT_URI() {
        return `${this.API_BASE}/api/oauth/callback`;
    },
    
    // Share system URLs
    get PUBLIC_SHARE_URL() {
        return `${this.SHARE_URL}/share`;
    },
    get PUBLIC_FORM_URL() {
        return `${this.SHARE_URL}/form`;
    },
    get PUBLIC_EMBED_URL() {
        return `${this.SHARE_URL}/embed`;
    },

    // Legacy compatibility
    get ADMIN_URL() {
        return this.APP_URL;
    },
    get FRONTEND_URL() {
        return this.APP_URL;
    },

    // Constants (not environment-specific)
    APP_NAME: 'GenOfX',
    MAIL_FROM_NAME: 'GenOfX',
    
    // Auth Settings
    ENABLE_AUTH_REDIRECT: false,

    GOOGLE_CLIENT_ID: env.VITE_GOOGLE_CLIENT_ID,
};

export default CONFIG;
